import { useState } from "react";
import { Link } from "react-router-dom";
import { useStore } from "./StoreContext";
import { storeApi } from "./storeApi";
import { countryName } from "./format";
import useSeo from "./useSeo";

function Field({ label, children }) {
  return (
    <label className="sh-field">
      <span className="sh-field-label">{label}</span>
      {children}
    </label>
  );
}

// Shown instead of the checkout to visitors from a country we don't ship to:
// they leave their details and cart, and the team arranges it by hand.
export default function InquiryForm({ onShipsHere }) {
  const { config, sellable, clear } = useStore();
  const [f, setF] = useState({ name: "", email: "", phone: "", country: countryName(config.visitorCountry), address: "", message: "", website: "" });
  const [state, setState] = useState({ busy: false, error: null, sent: false });
  useSeo({ title: "Shipping inquiry", noindex: true, path: "/merch/checkout" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, error: null, sent: false });
    try {
      await storeApi.inquiry({ ...f, items: sellable.map((l) => ({ productId: l.id, qty: l.qty })) });
      clear();
      setState({ busy: false, error: null, sent: true });
    } catch (err) {
      setState({ busy: false, error: err.message, sent: false });
    }
  };

  if (state.sent) {
    return (
      <div className="sh-wrap sh-checkout">
        <h1 className="sh-h1">Thanks!</h1>
        <p>We'll get back to you by email to arrange the shipping.</p>
        <Link className="sh-btn" to="/merch">
          Continue shopping
        </Link>
      </div>
    );
  }

  return (
    <div className="sh-wrap sh-checkout">
      <header className="sh-pagehead">
        <h1 className="sh-h1">We don't ship to {countryName(config.visitorCountry)} yet</h1>
        <Link className="sh-textlink" to="/merch/cart">
          Back to cart
        </Link>
      </header>
      <form className="sh-form" onSubmit={submit}>
        <input name="website" value={f.website} onChange={set("website")} className="sh-hp" tabIndex={-1} autoComplete="off" aria-hidden="true" />
        <p>Leave your details and we'll arrange the shipping with you by email.</p>
        <Field label="Full name">
          <input required value={f.name} onChange={set("name")} autoComplete="name" />
        </Field>
        <Field label="Email">
          <input type="email" required value={f.email} onChange={set("email")} autoComplete="email" inputMode="email" />
        </Field>
        <Field label="Phone (optional)">
          <input type="tel" value={f.phone} onChange={set("phone")} autoComplete="tel" />
        </Field>
        <Field label="Country">
          <input required value={f.country} onChange={set("country")} autoComplete="country-name" />
        </Field>
        <Field label="Delivery address">
          <textarea rows={3} required value={f.address} onChange={set("address")} autoComplete="street-address" />
        </Field>
        <Field label="Message (optional)">
          <textarea rows={2} value={f.message} onChange={set("message")} />
        </Field>
        {state.error && <p className="sh-error">{state.error}</p>}
        <button className="sh-btn sh-btn-xl" disabled={state.busy || !sellable.length}>
          {state.busy ? "Sending…" : "Send inquiry"}
        </button>
        <button type="button" className="sh-textlink" onClick={onShipsHere}>
          Actually, I'm in a country you ship to
        </button>
      </form>
    </div>
  );
}
